import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=3270ecb2&scoped=true&"
import script from "./Login.vue?vue&type=script&lang=ts&"
export * from "./Login.vue?vue&type=script&lang=ts&"
import style0 from "./Login.vue?vue&type=style&index=0&id=3270ecb2&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270ecb2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notice: require('C:/inetpub/wwwroot/bike-flights/components/Notice.vue').default})
